import type { MyFeatureAccessMap } from '@/services/feature-access-api'

/**
 * Sidebar'da Kai girişi YALNIZ erişim haritası `page_chatbot.allowed === true` derse açılır (D-04, D-06).
 * Harita yükleniyor (undefined), hata, anahtar yok, `false`, `"true"`, `1` → kilitli ("Çok yakında").
 * `decidePageAccess`'in `legacy` geri düşüşü (hata = herkese açık) Kai için BİLİNÇLİ olarak kullanılmaz.
 */
export function isKaiNavUnlocked(accessMap: MyFeatureAccessMap | undefined): boolean {
  return accessMap?.['page_chatbot']?.allowed === true
}
